export default __webpack_public_path__ + "static/6374-actuator-c760442e4996871e6b63a06297c3100c.png";